module.exports = __webpack_public_path__ + "img/trial1-1.6f0ac116.png";